import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
      <Typography variant="h3" color="error">
        403
      </Typography>
      <Typography variant="h5">Nemate dozvolu za pristup ovoj stranici.</Typography>
      <Typography variant="body2" color="text.secondary">
        Kontaktirajte administratora ako smatrate da je ovo greška.
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)}>
        Nazad
      </Button>
    </Box>
  );
};
